import React from 'react';
import { motion } from 'framer-motion';
import { Check, X, Flag } from 'lucide-react';
export function ComparisonCard() {
  return <div className="grid md:grid-cols-2 gap-6 my-10" data-id="element-38">
      {/* Canada Card */}
      <motion.div initial={{
      opacity: 0,
      x: -20
    }} whileInView={{
      opacity: 1,
      x: 0
    }} viewport={{
      once: true
    }} className="bg-white rounded-xl shadow-lg border-2 border-green-500 overflow-hidden relative" data-id="element-39">
        <div className="bg-green-50 p-4 border-b border-green-100 flex items-center justify-between" data-id="element-40">
          <div className="flex items-center gap-2" data-id="element-41">
            <span className="text-2xl" data-id="element-42">🇨🇦</span>
            <h3 className="font-bold text-xl text-green-900" data-id="element-43">Canada</h3>
          </div>
          <span className="bg-green-200 text-green-800 text-xs font-bold px-2 py-1 rounded-full uppercase" data-id="element-44">
            Winner
          </span>
        </div>
        <div className="p-6 space-y-4" data-id="element-45">
          <div className="flex items-start gap-3" data-id="element-46">
            <Check className="w-5 h-5 text-green-600 mt-1" data-id="element-47" />
            <div data-id="element-48">
              <p className="font-bold text-slate-900" data-id="element-49">Tax-Free Winnings</p>
              <p className="text-sm text-slate-600" data-id="element-50">
                Recreational players keep 100%
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3" data-id="element-51">
            <Check className="w-5 h-5 text-green-600 mt-1" data-id="element-52" />
            <div data-id="element-53">
              <p className="font-bold text-slate-900" data-id="element-54">No Withholding</p>
              <p className="text-sm text-slate-600" data-id="element-55">Casinos pay out fully</p>
            </div>
          </div>
          <div className="flex items-start gap-3" data-id="element-56">
            <Check className="w-5 h-5 text-green-600 mt-1" data-id="element-57" />
            <div data-id="element-58">
              <p className="font-bold text-slate-900" data-id="element-59">No Reporting</p>
              <p className="text-sm text-slate-600" data-id="element-60">No forms to file</p>
            </div>
          </div>

          <div className="mt-6 p-4 bg-green-50 rounded-lg border border-green-100" data-id="element-61">
            <p className="text-sm font-medium text-green-900" data-id="element-62">
              Example Win: $10,000
            </p>
            <p className="text-2xl font-bold text-green-700" data-id="element-63">
              You Keep: $10,000
            </p>
          </div>
        </div>
      </motion.div>

      {/* USA Card */}
      <motion.div initial={{
      opacity: 0,
      x: 20
    }} whileInView={{
      opacity: 1,
      x: 0
    }} viewport={{
      once: true
    }} className="bg-white rounded-xl shadow-lg border-2 border-red-200 overflow-hidden" data-id="element-64">
        <div className="bg-red-50 p-4 border-b border-red-100 flex items-center justify-between" data-id="element-65">
          <div className="flex items-center gap-2" data-id="element-66">
            <span className="text-2xl" data-id="element-67">🇺🇸</span>
            <h3 className="font-bold text-xl text-red-900" data-id="element-68">United States</h3>
          </div>
        </div>
        <div className="p-6 space-y-4" data-id="element-69">
          <div className="flex items-start gap-3" data-id="element-70">
            <X className="w-5 h-5 text-red-500 mt-1" data-id="element-71" />
            <div data-id="element-72">
              <p className="font-bold text-slate-900" data-id="element-73">Fully Taxable</p>
              <p className="text-sm text-slate-600" data-id="element-74">
                All gambling wins are income
              </p>
            </div>
          </div>
          <div className="flex items-start gap-3" data-id="element-75">
            <X className="w-5 h-5 text-red-500 mt-1" data-id="element-76" />
            <div data-id="element-77">
              <p className="font-bold text-slate-900" data-id="element-78">
                24% Federal Withholding
              </p>
              <p className="text-sm text-slate-600" data-id="element-79">On wins over $1,200</p>
            </div>
          </div>
          <div className="flex items-start gap-3" data-id="element-80">
            <X className="w-5 h-5 text-red-500 mt-1" data-id="element-81" />
            <div data-id="element-82">
              <p className="font-bold text-slate-900" data-id="element-83">Mandatory Reporting</p>
              <p className="text-sm text-slate-600" data-id="element-84">Must file on tax return</p>
            </div>
          </div>

          <div className="mt-6 p-4 bg-red-50 rounded-lg border border-red-100" data-id="element-85">
            <p className="text-sm font-medium text-red-900" data-id="element-86">
              Example Win: $10,000
            </p>
            <p className="text-2xl font-bold text-red-700" data-id="element-87">You Keep: ~$7,000</p>
          </div>
        </div>
      </motion.div>
    </div>;
}